<template>
  <div>
    <form class="needs-validation" @submit.prevent="confirmDeletePackage">
      <div class="form-group">
        <label for="package_id">ID партнера</label>
        <p id="package_id" class="form-control form-control-sm">{{currentPartnerData.id}}</p>
      </div>
      <div class="form-group">
        <label for="package_date">Наименование главного юр.лица</label>
        <p id="package_date" class="form-control form-control-sm">{{currentPartnerData.mainName}}</p>
      </div>
      <div class="form-group">
        <label for="package_date">Наименование подчиненного юр.лица</label>
        <p id="package_date" class="form-control form-control-sm">{{currentPartnerData.slaveName}}</p>
      </div>
    </form>
  </div>

</template>

<script>

import axios from "axios";

export default {
  name: "DeletePartner",
  data() {
    return {
      currentPartnerData: {
        id: null,
        mainName: null,
        slaveName: null,
      },
      submitted: false,
      defaultPayer: null,
    }
  },
  mounted() {
  },
  props: {
  },
  watch: {
  },
  computed: {

  },
  validations: {
  },
  methods: {
    setNullFormDate() {
      this.currentPartnerData = {
        id: null,
        mainName: null,
        slaveName: null,
      };
    },
    setFormData(id, mainName, slaveName) {
      this.currentPartnerData = {
        id: id,
        mainName: mainName,
        slaveName: slaveName,
      };
    },
    confirmDeletePartner() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.currentPartnerData.$touch();
      if (!this.$v.currentPartnerData.$invalid) {
        this.$emit('confirmDeletePartner', this.currentPartnerData);
      }
    },
    deletePartner(){
      let formData = new FormData();
      formData.append('id', this.currentPartnerData.id);
      axios
          .post(`/v1/partners/custom-delete`, formData)
          .then(resp => {
            alert('Партнер c id=' + this.currentPartnerData.id + ' удален.');
            this.$emit('partner-deleted');
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
  },
  created() {

  }
};
</script>

<style scoped lang="css">

</style>
